const BASE_URL        = '/api';
const CLIENT_BASE_URL = '/api/client/v1';

function getToken() {
  return localStorage.getItem('ptm_token');
}

function getClientToken() {
  return localStorage.getItem('ptm_client_token') || localStorage.getItem('ptm_token');
}

export function setClientToken(token) {
  localStorage.setItem('ptm_client_token', token);
}

export function clearClientToken() {
  localStorage.removeItem('ptm_client_token');
}

async function request(method, path, body, baseUrl, tokenFn) {
  const headers = { 'Content-Type': 'application/json' };
  const token = tokenFn();
  if (token) headers['Authorization'] = 'Bearer ' + token;
  const opts = { method, headers };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(baseUrl + path, opts);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || 'Request failed');
  return data;
}

export const api = {
  get:    (path)       => request('GET',    path, null, BASE_URL,        getToken),
  post:   (path, body) => request('POST',   path, body, BASE_URL,        getToken),
  put:    (path, body) => request('PUT',    path, body, BASE_URL,        getToken),
  delete: (path)       => request('DELETE', path, null, BASE_URL,        getToken),
};

export const clientApi = {
  get:    (path)       => request('GET',    path, null, CLIENT_BASE_URL, getClientToken),
  post:   (path, body) => request('POST',   path, body, CLIENT_BASE_URL, getClientToken),
  put:    (path, body) => request('PUT',    path, body, CLIENT_BASE_URL, getClientToken),
  delete: (path)       => request('DELETE', path, null, CLIENT_BASE_URL, getClientToken),
};
